import React, { Component } from 'react';
import styles from './logo.module.scss';
import SimLogo from './../../../globals/images/logo.png';
import PropTypes from 'prop-types';

class Logo extends Component {
    render() {
        return (
            <div className={styles.container}>
                <img style={{ width: '240px' }} src={SimLogo}></img>
                <div style={{ marginLeft: '10px', fontSize: '22px' }}>BETA</div>
            </div>
        );
    }
}

export default Logo;



// WEBPACK FOOTER //
// /src/components/UiComponents/Logo/Logo.js